"use strict";

var e = require("./_commonjsHelpers-f10b257f.js"),
  t = e.createCommonjsModule(function (e) {
    function t() {
      return e.exports = t = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
        }
        return e;
      }, e.exports.__esModule = !0, e.exports["default"] = e.exports, t.apply(this, arguments);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports["default"] = e.exports;
  }),
  r = e.getDefaultExportFromCjs(t);
exports._extends = r;